module.exports = __webpack_public_path__ + "static/media/marker.1d292127.svg";